import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICON } from '@core/util/icon';
import * as actions from '../../idle-timeout.actions';

export interface IdleTimeoutWarningDialogData {
	countdownSeconds: number;
}

@Component({
	selector: 'app-idle-timeout-warning',
	templateUrl: './idle-timeout-warning.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdleTimeoutWarningComponent implements OnInit {
	ICON = ICON;
	remainingSeconds$!: Observable<number>;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: IdleTimeoutWarningDialogData,
		private store: Store,
	) {}

	ngOnInit(): void {
		const maxTime = this.data.countdownSeconds;
		this.remainingSeconds$ = timer(0, 1000).pipe(
			map((current) => maxTime - current),
			map((remaining) => {
				const safeRemaining = Math.max(remaining, 0);
				if (!safeRemaining) {
					this.logoff();
				}

				return remaining;
			}),
		);
	}

	stayLoggedIn(): void {
		this.store.dispatch(new actions.ResetIdleTimeoutFromWarningDialog());
	}

	logoff(manual?: boolean): void {
		this.store.dispatch(new actions.Logout(manual));
	}
}
